import React from 'react';
import PropTypes from 'prop-types';
import {ThemeContext} from '../../common';

const TeamPoints = (props) => {
  const {name, points = 0} = props;

  return (
    <ThemeContext.Consumer>
      {theme => (
        <div className="team-points" style={{backgroundColor: theme.primaryColor}}>{name}/Points {points}</div>
      )}
    </ThemeContext.Consumer>
  );
};

TeamPoints.propTypes = {
  name: PropTypes.string.isRequired,
  points: PropTypes.number.isRequired,
};

export default TeamPoints;
